import React, { useState, useEffect } from 'react';
import './ImageSlider.css';
import image1 from './image1.png';
import image2 from './image2.png';
import image3 from './image3.png';
import image4 from './image4.png';
import image5 from './image5.png';

const images = [image1, image2, image3, image4, image5];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + images.length - 1) % images.length);
  };

  return (
    <div id="home" className="slider">
      <div
        className="slides"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: 'transform 0.5s ease-in-out',
        }}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="slide"
            style={{
              backgroundImage: `url(${image})`,
            }}
          />
        ))}
      </div>
      
    </div>
  );
};

export default ImageSlider;
